export default __webpack_public_path__ + "static/media/S_wdt_c_cap_2.372162e8.mp3";